import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private itemsSource = new Subject<MenuItem[]>();
  public itemsHandler = this.itemsSource.asObservable();

  setItems(items: MenuItem[]) {
      this.itemsSource.next(items);
  }

}
